import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { isNumber } from "../../global";
import GHSHazardInformation from '../../api/LIMS/GHSHazardInformation';

const ValidatedPSIMSIDTextField = ({ isDisabled, margin, showLabel, fieldWidth, PSIMSIDObject, setPSIMSIDObject, hasErrors, setHasErrors, autoSearch = true }) => {

    const theme = useTheme();
    const [PSIMSIDSearchValue, setPSIMSIDSearchValue] = useState("")
    const [coloring, setColoring] = useState(theme.palette.primary)
    const [label, setLabel] = useState("PSIMS ID")
    const firstExecution = useRef(true)

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            setPSIMSIDSearchValue(event.target.value)
            fieldLeaveAndValidate()
        }
    }

    const fieldChange = (value) => {
        setPSIMSIDSearchValue(value)
        if (PSIMSIDObject === null || PSIMSIDObject === '') {
            if (autoSearch)
            {
                fieldLeaveAndValidate(value);
            }

        } else if (autoSearch) 
        {
            fieldLeaveAndValidate(value);
        } else {
            setPSIMSIDObject(value)
            setLabel("PSIMS ID")
            setColoring(theme.palette.primary)
        }
    } 

    const fieldLeaveAndValidate = (searchValue) => {
        searchValue = searchValue ?? PSIMSIDSearchValue;
        
        setHasErrors(PSIMSIDObject === null)
        let cancelPromise = false
    
        if (searchValue && searchValue !== "") {
            GHSHazardInformation.getFromPSIMSID(searchValue).then((res) => {
                if (cancelPromise) return

                if (res) {
                    if (res?.psimsid !== null)
                    {
                        if (res.isActive) {
                            var number = scannerGHS(false)
                            setPSIMSIDObject(res.psimsid, number)
                            setLabel("Valid PSIMS ID")
                            setColoring("green")
                            setHasErrors(false) 
                        }
                        else {
                            // setPSIMSIDObject('')
                            setHasErrors(true)
                            setLabel("Inactive in MIDAS")
                            setColoring(theme.palette.primary)
                        }
                        
                    } else {
                        // setPSIMSIDObject('')
                        setHasErrors(true)
                        setLabel("Not found in MIDAS")
                        setColoring(theme.palette.primary)
                    }
                   
                } else {
                    // setPSIMSIDObject('')
                    setHasErrors(true)
                    setLabel("Not found in MIDAS")
                    setColoring(theme.palette.primary)
                }
            });
        } else {
            setHasErrors(false)
            setPSIMSIDObject('')
            setLabel("PSIMS ID")
            setColoring(theme.palette.primary)
        }
        
        return () => {
            cancelPromise = true
        }
    }

     const scannerGHS = (setScanned = true) => {
        let psimsid = null

        if (PSIMSIDSearchValue !== null && PSIMSIDSearchValue !== '')
        {
            if (isNumber(PSIMSIDSearchValue)) 
            {
                psimsid = parseInt(PSIMSIDSearchValue)
            } 
        } 

        return psimsid;
    }

    useEffect(() => {
        if (PSIMSIDObject && PSIMSIDObject !== null)
        {
            setLabel("Valid PSIMS ID")
            setColoring("green")
            setPSIMSIDSearchValue(PSIMSIDObject)
            setHasErrors(false)
        } else {
            setLabel("PSIMS ID")
            setColoring(theme.palette.primary)
            setPSIMSIDSearchValue('')
            setHasErrors(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PSIMSIDObject])
    
    useEffect(() => {
        if (!firstExecution)
            return;
        if (PSIMSIDSearchValue !== '' && PSIMSIDSearchValue !== null) {            
            fieldLeaveAndValidate()
            firstExecution.current = false
        }
    // This should run only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PSIMSIDSearchValue])

  
  return (
    <>
        <TextField sx={{width:fieldWidth,
                [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
                    borderColor: coloring
                },

                [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
                    borderColor: coloring
                },
                [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
                    borderColor: coloring
                },
                [`& .${outlinedInputClasses.input}`]: {
                    color: coloring
                },

                [`&:hover .${outlinedInputClasses.input}`]: {
                    color: coloring
                },
                [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.input}`]: {
                    color: coloring
                },
                [`& .${inputLabelClasses.outlined}`]: {
                    color: coloring
                },

                [`&:hover .${inputLabelClasses.outlined}`]: {
                    color: coloring
                },
                [`& .${inputLabelClasses.outlined}.${inputLabelClasses.focused}`]: {
                    color: coloring
                }
                }} 

                disabled = {isDisabled}
                size="small" margin={margin} variant="outlined" label= {showLabel ? label : null} InputLabelProps={{shrink: true}}
                onKeyDown={e => handleKeyPress(e)}
                onChange={e => fieldChange(e.target.value.replace(/\D/g, ''))}
                value={PSIMSIDSearchValue}
                placeholder="PSIMS ID"
                
                error = {hasErrors}
                onBlur = {() => autoSearch ? {} : (PSIMSIDObject ? {} : fieldLeaveAndValidate())}
                //onBlur = {() => autoSearch ? {} : fieldLeaveAndValidate()}
                >
        </TextField>
    </>
  );
}
export default ValidatedPSIMSIDTextField;


